import styled from "styled-components";

const ErrorBanner = styled.div`
  background: #fee2e2;
  border: 2px solid #ef4444;
  color: #991b1b;
  padding: 16px;
  border-radius: 12px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;

  .error-icon {
    font-size: 24px;
  }
  .error-text {
    flex: 1;
  }
  .close-btn {
    background: transparent;
    border: none;
    color: #991b1b;
    cursor: pointer;
    font-size: 20px;
    padding: 4px 8px;
    border-radius: 4px;
    &:hover {
      background: #fecaca;
    }
  }
`;

export default ErrorBanner;